import * as React from 'react';
import TextInput from '@packages/systems/design-system/TextInput';
import {Label} from './LinkUIComponents';
import {dissoc} from '@packages/utilities/key-map';
import {LinkPreload} from './LinkPreload';
import {LinkTarget} from './LinkTarget';
import type {State} from './LinkTypes';

const useUrl = (state: State, dispatch: (arg1?: any) => void) => {
  const [url = '#', setUrl] = React.useState(state.url);

  const onChange = (e: React.SyntheticEvent<HTMLInputElement>) =>
    setUrl(e.currentTarget.value);

  const onBlur = React.useCallback(() => {
    let newState = {...state, url};

    // Remove `url` from data when blank
    if (url === '') {
      // @ts-expect-error - TS2739 - Type '{ [key: string]: any; }' is missing the following properties from type '{ url: string; mode: Mode; pageId?: string | undefined; domId?: string | undefined; email?: string | undefined; subject?: string | undefined; tel?: string | undefined; assetId?: string | undefined; target?: "_self" | ... 1 more ... | undefined; preload?: "none" | ... 2 more ... | undefined; }': url, mode
      newState = dissoc('url')(newState);
    }

    dispatch({
      payload: newState,
      meta: {analytics: {type: 'element-settings-updated', value: 'url'}},
    });
  }, [dispatch, state, url]);

  React.useEffect(() => setUrl(state.url), [state.url]);

  return {onChange, onBlur, url};
};

export const LinkExternalMode = ({
  state,
  dispatch,
  isOverride,
  hasLegacyDynamoHrefBinding,
}: {
  state: State;
  dispatch: (arg1?: any) => void;
  isOverride: boolean;
  hasLegacyDynamoHrefBinding?: boolean;
}) => {
  const {url, onBlur, onChange} = useUrl(state, dispatch);

  return (
    <>
      {/* URL */}
      {hasLegacyDynamoHrefBinding ? null : (
        <>
          <Label
            data-automation-id="symbols-dataType-contentType"
            isOverride={isOverride}
          >
            URL
          </Label>
          <TextInput
            data-automation-id="Type--Plugin_Text_URL"
            onBlur={onBlur}
            onChange={onChange}
            placeholder="e.g https://www.google.com"
            type="text"
            value={url}
          />
        </>
      )}
      {/* Target */}
      <Label
        data-automation-id="symbols-dataType-contentType"
        isOverride={isOverride}
      >
        Open in
      </Label>
      <LinkTarget state={state} dispatch={dispatch} />
      {/* Preload */}
      <Label
        data-automation-id="symbols-dataType-contentType"
        isOverride={isOverride}
      >
        Preload
      </Label>
      <LinkPreload state={state} dispatch={dispatch} />
    </>
  );
};
